import React from 'react';

import RecruiterHighlights from './RecruiterHighlights';
import About from './About';
import Education from './Education';
import Service from './Service';
import Project from './Project';
import Hackathon from './Hackathon';
import Certificates from './Certificates';
import Contact from './Contact';

const Main = () => (
  <main>
    <RecruiterHighlights />
    <About />
    <Education />
    <Service />
    <Project />
    <Hackathon />
    <Certificates />
    <Contact />
  </main>
);

export default Main;
